import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../base/ui/components/web/Button';
import { loadWhiteboard } from '../../loadWhiteboard.web';
import logger from '../../logger';
/** Download drawing tools only while their view is mounted. */
export default function LazyExcalidraw(props) {
    const { t } = useTranslation();
    const [Drawing, setDrawing] = useState(null);
    const [failed, setFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true;
        loadWhiteboard().then(module => {
            if (active)
                setDrawing(() => module.ExcalidrawApp);
        }).catch(() => {
            if (active) {
                logger.warn('Whiteboard interface download failed.');
                setFailed(true);
            }
        });
        return () => { active = false; };
    }, [attempt]);
    if (Drawing)
        return React.createElement(Drawing, { ...props });
    return (React.createElement("div", { style: { fontSize: 16, lineHeight: '24px', padding: 24 } },
        React.createElement("p", { role: failed ? 'alert' : 'status' }, t(failed ? 'whiteboard.loadFailed' : 'whiteboard.loading')),
        failed && React.createElement(Button, { labelKey: 'dialog.retry', onClick: () => { setFailed(false); setAttempt(value => value + 1); } })));
}
